// @ts-nocheck

import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'

export const formatDate = (date) => dayjs(date).format('DD-MM-YYYY HH:mm')

export const getColor = (data) => {
  const item = data.item && data.item.color ? data.item : data.category
  return item && item.color ? item.color : colors.darkblue
}

export const getIcon = (data) => {
  const item = data.item && data.item.icon ? data.item : data.category
  return item && item.icon ? item.icon : ''
}
export const getWitnessName = (witnessedBy) => {
  return witnessedBy.name && witnessedBy.name.first && witnessedBy.name.last
    ? `${witnessedBy.name.first} ${witnessedBy.name.last}`
    : ''
}
